import * as defaultAxios from 'axios';
import { joinPaths } from '@tanstack/react-router';
const host = '/api';
const apiVersion = '/v1';
const locale = sessionStorage.getItem('locale') || 'en';
export const apiAxios = defaultAxios.default.create({
    baseURL: joinPaths([host, apiVersion, locale]),
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
    withCredentials: true,
});
export const axios = defaultAxios.default.create({
    baseURL: host,
});
const ResponseHandler = (response) => {
    return response;
};
const ResponseErrorHandler = async (error) => {
    const { response: { status, data }, config, } = error;
    if (status === 401 &&
        ['Invalid JWT Token', 'Expired JWT Token', 'JWT Token not found'].includes(data.message) &&
        !config.__isRetryRequest) {
        config.__isRetryRequest = true;
        try {
            await axios.post('/token/refresh');
            return apiAxios(config);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    return Promise.reject(error);
};
apiAxios.interceptors.response.use((response) => ResponseHandler(response), (error) => ResponseErrorHandler(error));
